import React from 'react';

function Parralox() {
    return <div>

        <div class="relative">
            <div class="absolute inset-0 bg-fixed bg-cover bg-center" style={{
                backgroundImage: "url('https://i.ibb.co/7WsVBrg/4003182038.png')",
            }}></div>
            <div class="relative z-10 h-96 flex justify-center items-center bg-black bg-opacity-70">
                <div class="container flex flex-col justify-center items-center">
                    <h1 class="mb-4 hover:underline hover:text-blue-100 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl">Welcome to VSPSMUN'24</h1>
                    <div class="mb-1">
                        <a href="#" class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900">
                            <span>Register now</span>
                            <svg aria-hidden="true" class="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="p-10 space-y-8 grid grid-cols-1 md:grid-cols-2 gap-8 bg-gradient-to-b from-blue-200 to-white-100 font-serif">
            <div>
                <h1 className="text-left text-4xl font-bold text-black sm:text-6xl lg:text-7xl">
                    <div className="relative inline-flex">
                        <span className="absolute inset-x-0 bottom-0 border-b-[30px] border-[#7cb5e4]"></span>
                        <h1 className="text-left relative text-2xl font-bold text-black sm:text-2xl lg:text-2xl hover:underline">
                            About Us
                        </h1>
                    </div>
                </h1>
                <p className="text-left grid-cols-2 gap-8">
                    VSPSMUN is a simulation of the United Nations held at DR VSPS Cantt, Kanpur, Uttar Pradesh, India. We believe in the great strength of youth and their ability to change the world for the better. We provide a platform for students to discuss and debate current global issues from the perspective of different countries, which helps enhance their public speaking, debating, and problem-solving skills. Donec eros risus, porttitor eget risus vel, pulvinar hendrerit ante. Maecenas quis pretium metus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Nulla facilisi. Nam rutrum, augue et sagittis aliquam, mi nisi lobortis enim, eget egestas sapien urna in turpis. Quisque scelerisque dolor sagittis lorem accumsan, at tempus odio convallis. Nulla venenatis pulvinar ipsum vel auctor. Praesent a enim at erat fringilla lacinia. Aenean eu ultrices ante.
                </p>
            </div>
        </div>




    </div>;
}

export default Parralox;
